<script>
export default {
  components: {},
  props: {
    data: {
      type: Object,
      default: {},
    },
  },
  computed: {
    sinAforo() {
      return this.data;
    },
  },
};
</script>

<template>
  <div class="flex flex-col gap-8 w-full">
    <div class="flex flex-col gap-4 w-full">
      <div class="grid grid-cols-2 border-b border-primary/20">
        <div class="text-left">Fecha Inspección</div>
        <div class="font-bold text-right">
          {{ sinAforo.fecha_inspeccion ?? "-" }}
        </div>
      </div>

      <div class="grid grid-cols-2 border-b border-primary/20">
        <div class="text-left">N° Sello</div>
        <div class="font-bold text-right">
          {{ sinAforo?.numero_sello ?? "-" }}
        </div>
      </div>
    </div>
  </div>
</template>
